import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import Navbar from './Navbar';
import { useTranslation } from 'react-i18next';

const RegisterPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [confirmEmail, setConfirmEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const roles = ['student', 'teacher'];
  const [error, setError] = useState('');

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');

    if (email !== confirmEmail) {
      setError(t('auth.emailMismatch'));
      return;
    }

    if (password !== confirmPassword) {
      setError(t('auth.passwordMismatch'));
      return;
    }

    try {
      const response = await axios.post('https://amora-backend.onrender.com/api/auth/register', {
        name,
        email,
        password,
        roles,
      });

      if (response.data.success) {
        alert(t('auth.registrationSuccess'));
        navigate('/login');
      } else {
        setError(response.data.message || t('auth.registrationFailed'));
      }
    } catch (err) {
      console.error('Registration error:', err.response?.data || err.message);
      const message = err.response?.data?.error || t('auth.registrationFailed');
      setError(message);
    }
  };

  return (
    <>
      <Navbar user={null} />
      <div className="min-h-[calc(100vh-64px)] bg-[#fcfaf4] text-[#1a1a1a] flex flex-col items-center justify-center px-4 py-10">
        <h2 className="text-2xl font-extrabold uppercase text-center tracking-wide mb-6">📝 {t('auth.registerTitle')}</h2>

        <form
          onSubmit={handleRegister}
          className="bg-white border border-black p-8 w-full max-w-md space-y-4 font-serif"
        >
          <input
            type="text"
            placeholder={t('auth.fullName')}
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            className="w-full border border-black bg-white text-black px-3 py-2 uppercase tracking-wide font-medium"
          />
          <input
            type="email"
            placeholder={t('auth.email')}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full border border-black bg-white text-black px-3 py-2 uppercase tracking-wide font-medium"
          />
          <input
            type="email"
            placeholder={t('auth.confirmEmail')}
            value={confirmEmail}
            onChange={(e) => setConfirmEmail(e.target.value)}
            required
            className="w-full border border-black bg-white text-black px-3 py-2 uppercase tracking-wide font-medium"
          />

          <div className="relative">
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder={t('auth.password')}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full border border-black bg-white text-black px-3 py-2 uppercase tracking-wide font-medium"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-2 text-sm"
              tabIndex={-1}
            >
              {showPassword ? '🙈' : '👁'}
            </button>
          </div>

          <input
            type={showPassword ? 'text' : 'password'}
            placeholder={t('auth.confirmPassword')}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            className="w-full border border-black bg-white text-black px-3 py-2 uppercase tracking-wide font-medium"
          />

          <button
            type="submit"
            className="w-full border border-black bg-white text-black px-4 py-2 font-bold uppercase tracking-wide hover:bg-black hover:text-white transition"
          >
             {t('auth.registerButton')}
          </button>

          {error && <p className="text-red-600 text-sm text-center">{error}</p>}
        </form>

        <p className="mt-6 text-xs font-medium text-[#4c4532]">
          {t('auth.haveAccount')}{' '}
          <Link to="/login" className="underline hover:text-black transition">
            {t('auth.loginLink')}
          </Link>
        </p>
      </div>
    </>
  );
};

export default RegisterPage;
